import script from "./index.vue?vue&type=script&setup=true&name=Home&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Home&lang=js"

import "./index.vue?vue&type=style&index=0&id=c471f040&lang=scss"

const __exports__ = script;

export default __exports__